document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const section = document.querySelector('.section-ingredients-out');
    if (!section || !section.contains(e.target)) return;

    const header = e.target.closest('.ingredients-out-item .item-title');
    if (!header) return;

    e.preventDefault();
    const item = header.closest('.ingredients-out-item');
    if (!item) return;

    const isOpen = item.classList.toggle('ingredients-out-accordion-open');
    header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
});
